// ProfilePage.jsx

import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  Paper,
  Typography,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import axios from "axios";
// Components
import ProfileHeader from "./ProfileDashboardCards/ProfileHeader";
import QuickStats from "./ProfileDashboardCards/QuickStats";
import ActivitySection from "./ProfileDashboardCards/ActivitySection";
import PersonalSection from "./ProfileDashboardCards/PersonalSection";
import AccountSection from "./ProfileDashboardCards/AccountSection";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";


// Uncomment these once you create them
// import EditProfileDialog from "./ProfileDashboardCards/EditProfileDialog";
// import ChangePasswordDialog from "./ProfileDashboardCards/ChangePasswordDialog";
// import LogoutDialog from "./ProfileDashboardCards/LogoutDialog";

const ProfileDashboard = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const [user, setUser] = useState({
    name: "",
    email: "",
    phone: "",
    avatar: "",
  });

  const [stats, setStats] = useState({
    orders: 0,
    reports: 0,
    prescriptions: 0,
    rewardPoints: 0,
    complaints: 0,
    feedback: 0,
  });

  const [editOpen, setEditOpen] = useState(false);
  const [passwordOpen, setPasswordOpen] = useState(false);
  const [logoutOpen, setLogoutOpen] = useState(false);

  useEffect(() => {
    loadProfile();
  }, []);


  const loadProfile = async () => {
    try {
      setLoading(true);
      const userId = sessionStorage.getItem("userId");

       try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/user/${userId}/profile`);
            if (res.data.success) {
            setUser(res.data.user);
            setStats(res.data.stats);
            }
        } catch (err) {
            console.error(err);
        }

     
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box
        sx={{
          height: "80vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Container
        maxWidth="xl"
        sx={{
          py: 4,
          minHeight: "100vh",
          backgroundColor: "#f7f8fc",
        }}
      >
        {/* Profile Header */}

        <ProfileHeader
          user={user}
          onEdit={() => navigate("/profile-details")}
        />

        {/* Quick Stats */}

        <Box mt={4}>
          <QuickStats stats={stats} />
        </Box>

        {/* Main Layout */}

        <Grid container spacing={3} mt={1}>
          {/* Left Side */}

          <Grid item xs={12} lg={8}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 4,
                mb: 3,
                border: "1px solid #ECECEC",
              }}
            >
              <ActivitySection
                stats={stats}
                navigate={navigate}
              />
            </Paper>

           
          </Grid>

          {/* Right Side */}

          <Grid item xs={12} lg={4}>
           <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 4,
                border: "1px solid #ECECEC",
                mb: 3,
              }}
            >
              <PersonalSection
                familyCount={0}
                emergencyCount={0}
                addressCount={0}
                navigate={navigate}
              />
            </Paper>
            {/* Account */}

            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 4,
                border: "1px solid #ECECEC",
              }}
            >
              <AccountSection
                setEditOpen={setEditOpen}
                setPasswordOpen={setPasswordOpen}
                setLogoutOpen={setLogoutOpen}
              />
            </Paper>

            {/* Health Tip */}

            <Paper
              elevation={0}
              sx={{
                mt: 3,
                p: 3,
                borderRadius: 4,
                border: "1px solid #ECECEC",
              }}
            >
              <Typography
                variant="h6"
                fontWeight={700}
                gutterBottom
              >
                Health Tip
              </Typography>

              <Typography
                variant="body2"
                color="text.secondary"
                lineHeight={1.8}
              >
                Stay hydrated, maintain a balanced diet,
                exercise regularly, and schedule routine
                health checkups for a healthier lifestyle.
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>

      {/* Uncomment after creating these components */}

      {/*
      <EditProfileDialog
        open={editOpen}
        onClose={() => setEditOpen(false)}
        user={user}
      />

      <ChangePasswordDialog
        open={passwordOpen}
        onClose={() => setPasswordOpen(false)}
      />

      <LogoutDialog
        open={logoutOpen}
        onClose={() => setLogoutOpen(false)}
      />
      */}
    </>
  );
};

export default ProfileDashboard;